// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".exam-guide{font-family:\"Exo 2\",sans-serif !important;position:relative}", "",{"version":3,"sources":["webpack://./src/components/ExamGuide/ExamGuide.vue"],"names":[],"mappings":"AACA,YACE,yCAAA,CACA,iBAAA","sourcesContent":["\n.exam-guide {\n  font-family: 'Exo 2', sans-serif !important;\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
